import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";
import { useAuth } from "./auth";

const CartContext = createContext(null);

export function CartProvider({ children }) {
    const { user } = useAuth();
    const [cart, setCart] = useState({ items: [] });

    const fetchCart = useCallback(async () => {
        if (!user) {
            setCart({ items: [] });
            return;
        }
        try {
            const { data } = await api.get("/cart");
            setCart(data || { items: [] });
        } catch {
            setCart({ items: [] });
        }
    }, [user]);

    useEffect(() => { fetchCart(); }, [fetchCart]);

    const addToCart = async (payload, kind = "tshirt") => {
        const endpoint = kind === "template" ? "/cart/items/template"
                       : kind === "sticker"  ? "/cart/items/sticker"
                       : "/cart/items";
        const { data } = await api.post(endpoint, payload);
        setCart(data);
    };

    const removeItem = async (itemId) => {
        const { data } = await api.delete(`/cart/items/${itemId}`);
        setCart(data);
    };

    const clear = async () => {
        await api.delete("/cart");
        setCart({ items: [] });
    };

    const count = cart?.items?.length || 0;
    const total = cart?.items?.reduce((s, it) => s + (it.line_total || 0), 0) || 0;

    return (
        <CartContext.Provider value={{ cart, fetchCart, addToCart, removeItem, clear, count, total }}>
            {children}
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);
